import Breadcrumb from '../components/Breadcrumb'
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

function About() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
        });
    }, []);
    return (
        <>
            <Breadcrumb text='Loyiha haqida' />
            <section className="my-120 @">
                <div className="container-xl">
                    <div className="about-us-content v3">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="section-title">
                                    <div className="section-title-inner">
                                        <h4 className="sub-title" data-aos="fade-down" data-aos-duration="1000">Loyiha haqida</h4>
                                        <h2 className="big-title s-color-black" data-aos="fade-up" data-aos-duration="1000">Mediasavodxonlikni oshirishga qaratilgan raqamli loyiha</h2>
                                        <p className="title-para sp-color-black" data-aos="fade-up" data-aos-duration="1000">
                                            Platforma foydalanuvchilarda mediasavodxonlik ko‘nikmalarini rivojlantirish, axborotni tanqidiy tahlil qilish, tekshirish va xolis baholash qobiliyatlarini shakllantirishga qaratilgan raqamli ta’lim vositasi sifatida yaratilgan.
                                        </p>
                                    </div>
                                </div>
                                <ul className="check-box v2">
                                    <li className="box-item" data-aos="fade-right" data-aos-duration="1000">
                                        <div className="item-icon">
                                            <i className="my-icon icon-checkmark"></i>
                                        </div>
                                        <p className="item-para">Videodarslar</p>
                                    </li>
                                    <li className="box-item" data-aos="fade-right" data-aos-duration="1000">
                                        <div className="item-icon">
                                            <i className="my-icon icon-checkmark"></i>
                                        </div>
                                        <p className="item-para">24/7 Ta'lim</p>
                                    </li>
                                    <li className="box-item" data-aos="fade-right" data-aos-duration="1000">
                                        <div className="item-icon">
                                            <i className="my-icon icon-checkmark"></i>
                                        </div>
                                        <p className="item-para">Testlar</p>
                                    </li>
                                    <li className="box-item" data-aos="fade-right" data-aos-duration="1000">
                                        <div className="item-icon">
                                            <i className="my-icon icon-checkmark"></i>
                                        </div>
                                        <p className="item-para">Topshiriqlar</p>
                                    </li>
                                </ul>
                                <div className="founder-ceo" data-aos="fade-right" data-aos-duration="1000">
                                    <div className="founder-img">
                                        <img src="/assets/images/author.jpg" alt="founder-img" />
                                    </div>
                                    <div className="founder-data">
                                        <h2 className="title">A.Xudoyberdiyev  <span>Loyiha muallifi</span></h2>
                                        <p className="para">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam dolorem, nisi ipsum explicabo assumenda ipsa.
                                        </p>
                                    </div>
                                    <div className="ceo-sign-img">
                                        <img src="/assets/images/ceo-sign.png" alt="ceo-sign-img" />
                                    </div>
                                </div>
                                <p className="para" data-aos="fade-right" data-aos-duration="1000">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi incidunt, dignissimos ipsum nobis adipisci aspernatur obcaecati reprehenderit laboriosam sint dolor.
                                </p>
                            </div>
                            <div className="col-lg-5" data-aos="fade-left" data-aos-duration="1500">
                                <div className="about-us-left-content">
                                    <img src="/assets/images/right-img.png" alt="right-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About